import React from 'react';
import { styled } from '@mui/system';

const Container = styled('div')(({ theme }) => ({
  margin: '24px',
  [theme.breakpoints.down('md')]: {
    margin: '16px'
  },
  [theme.breakpoints.down('sm')]: {
    margin: '12px'
  },
  '& .breadcrumb': {
    marginBottom: '20px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '12px'
    }
  }
}));

const ContainerBody = ({ children }) => {
  return <Container>{children}</Container>;
};

export default ContainerBody;
